import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Typography
} from '@material-ui/core';
import MoneyIcon from '@material-ui/icons/Money';
import PaymentsIcon from '@material-ui/icons/Payment';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  chartContainer: {
    position: 'relative',
    height: '300px'
  },
  stats: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  device: {
    textAlign: 'center',
    padding: theme.spacing(1)
  },
  deviceIcon: {
    color: theme.palette.icon
  }
}));

const UsersByDevice = props => {
  const { className, savingsData, ...rest } = props;
  let total = savingsData.regular_savings +savingsData.target_savings + savingsData.save_loan
  let regular = Math.round((savingsData.regular_savings/total)*100);
  let target = Math.round((savingsData.target_savings/total)*100);
  let loan = Math.round((savingsData.save_loan/total)*100);
  const classes = useStyles();
  const theme = useTheme();

  const data = {
    datasets: [
      {
        data: [regular, target, loan],
        backgroundColor: [
          theme.palette.primary.main,
          theme.palette.error.main,
          theme.palette.warning.main
        ],
        borderWidth: 8,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white
      }
    ],
    labels: ['Regular', 'Target', 'Share Holdings']
  };

  const options = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.white,
      titleFontColor: theme.palette.text.primary,
      bodyFontColor: theme.palette.text.secondary,
      footerFontColor: theme.palette.text.secondary
    }
  };

  const devices = [
    {
      title: 'Regular',
      value: regular?regular:0,
      icon: <MoneyIcon />,
      color: theme.palette.primary.main
    },
    {
      title: 'Target',
      value: target?target:0,
      icon: <TrackChangesIcon />,
      color: theme.palette.error.main
    },
    {
      title: 'Share Holdings',
      value: loan?loan:0,
      icon: <PaymentsIcon />,
      color: theme.palette.warning.main
    }
  ];

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader
        title="All Savings Account"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          <Doughnut
            data={data}
            options={options}
          />
        </div>
        <div className={classes.stats}>
          {devices.map(device => (
            <div
              className={classes.device}
              key={device.title}
            >
              <span className={classes.deviceIcon}>{device.icon}</span>
              <Typography variant="body1">{device.title}</Typography>
              <Typography
                style={{ color: device.color }}
                variant="h2"
              >
                {device.value}%
              </Typography>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

UsersByDevice.propTypes = {
  className: PropTypes.string
};

export default UsersByDevice;
